import { useLocalObservable } from 'mobx-react-lite';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps } from '@gem/popups';

import Entities from 'STORE';

import {
  ICallSelectSpeakersPopupParams,
  ICallSelectSpeakersPopupPresenter,
} from './CallSelectSpeakersPopup.types';

export function useCallSelectSpeakersPresenter({
  params,
  popupInstance,
}: ICommonPopupsProps<ICallSelectSpeakersPopupParams>): ICallSelectSpeakersPopupPresenter {
  const { t } = useTranslation();

  const presenter = useLocalObservable<ICallSelectSpeakersPopupPresenter>(() => ({
    searchValue: '',
    selectedSpeakerIds: new Set(params!.activeSpeakerIds),

    get hasChanges(): boolean {
      const { activeSpeakerIds } = params!;
      return !(
        presenter.selectedSpeakerIds.size === activeSpeakerIds.length &&
        Array.from(presenter.selectedSpeakerIds).every((userId) =>
          activeSpeakerIds.includes(userId)
        )
      );
    },

    onClose(): void {
      popupInstance.close();
      params!.onClose();
    },

    onBack(): void {
      popupInstance.close();
      params!.onBack();
    },

    onSelectSpeaker(userId: string): void {
      if (Entities.usersStore.Me.id === userId) {
        return;
      }
      const { maxSpeakers } = params!;
      if (!presenter.selectedSpeakerIds.has(userId)) {
        if (presenter.selectedSpeakerIds.size < maxSpeakers) {
          presenter.selectedSpeakerIds.add(userId);
        } else {
          Entities.toast.show(t('webinar_speakers_limit_reached', { 0: maxSpeakers }));
        }
      } else {
        presenter.selectedSpeakerIds.delete(userId);
      }
    },

    onChangeSearch(value: string): void {
      presenter.searchValue = value;
    },

    submit(): void {
      if (presenter.hasChanges) {
        params!.onSubmit(Array.from(presenter.selectedSpeakerIds));
        presenter.onBack();
      }
    },
  }));

  return presenter;
}
